var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarBrush(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Brush"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.5835 8.75003L12.0835 11.25M17.9167 5.41663L10.3908 12.9426C9.70041 13.6329 8.58116 13.6329 7.89079 12.9426C7.20043 12.2523 7.20043 11.1329 7.89079 10.4426L15.4167 2.91663C16.1071 2.2263 17.2263 2.22627 17.9167 2.91658C18.6072 3.60693 18.6072 4.72626 17.9167 5.41663ZM8.61666 14.7917C8.61666 16.2874 7.40414 17.5 5.90836 17.5H2.0835L2.25875 17.4124C3.12207 16.9807 3.55246 15.9929 3.28072 15.0667C3.2272 14.8843 3.19512 14.6946 3.21497 14.5055C3.3579 13.1443 4.50924 12.0834 5.90836 12.0834C7.40414 12.0834 8.61666 13.2959 8.61666 14.7917Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarBrush);
export default __webpack_public_path__ + "static/media/sidebar-brush.de416ce1706dfcc121548963112a4a9f.svg";
export { ForwardRef as ReactComponent };